var map = {
	"./apr/12.png": "94b1",
	"./apr/apr-2.jpg": "48d6",
	"./aug/24.png": "6eb2",
	"./aug/25-eng.png": "69d5",
	"./dec/33-dec.png": "8cd1",
	"./dec/34-dec.png": "d634",
	"./dec/35-dec.png": "f01b",
	"./dec/36-dec.png": "f467",
	"./dec/37-dec.png": "20f7",
	"./feb/6.png": "272a",
	"./feb/7.png": "93cb",
	"./image-1.png": "3b5a",
	"./image-2.png": "131e",
	"./image-3.png": "c58c",
	"./intro/ok.svg": "f591",
	"./jan/2.png": "ac44",
	"./jan/jan-1.jpg": "5280",
	"./jan/jan-2.png": "090d",
	"./jan/jan-4.jpg": "50a5",
	"./jan/jan-5.jpg": "7b06",
	"./jul/21-eng.png": "9992",
	"./jul/2_1.png": "b752",
	"./jul/july-3.jpg": "34ac",
	"./jul/july-4.jpg": "368d",
	"./jun/17-eng.png": "09a2",
	"./jun/5g-1.png": "8911",
	"./jun/June--Hedera-Logo.png": "d3a4",
	"./mar/march-1.jpg": "2279",
	"./mar/march-2.jpg": "0a3f",
	"./mar/march-3.jpg": "3df2",
	"./mar/march-4.png": "610b",
	"./may/15-eng.png": "3786",
	"./may/may-3.jpg": "1fb5",
	"./may/zain_ramadan_tvc_2020-1.png": "e3f8",
	"./nov/28.png": "63af",
	"./nov/31.png": "8ba2",
	"./nov/Nov5G.png": "e21b",
	"./oct/28.png": "5c2f",
	"./oct/OTC-forbes_logo.png": "7230",
	"./sep/Nov5G.png": "66ae",
	"./sep/sep-2.jpg": "8a0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d760";